import React from "react";
import Githubcalendar from "react-github-calendar";
import styled from "./Github.module.css";

export const Github = () => {
	const colourTheme = {
		level0: "#F0F0F0",
		level1: "#C19A6B",
		level2: "#967969",
		level3: "#6F4E37",
		level4: "#2e1503",
	};

	return (
		<>
			<div className={styled.margin}>
				<h1 className={styled.mid}>
					Github - Days I <span className={styled.span}> Code</span>
				</h1>
				<Githubcalendar
					style={{ margin: "50px auto" }}
					username="GreatA-Maker"
					blockSize={15}
					blockMargin={5}
					theme={colourTheme}
					fontSize={16}
				/>
			</div>
		</>
	);
};
